@if (step(); as step) {
  <ion-row>
    <ion-col>
      @if (alfredClientService.showCloseButton()) {
        <lib-close-button
          [confirmClose]="!step.isAtEnd"
          [formState]="_questionFormCtrl"
        />
      }
      <lib-counter [step]="step" />
      @if (!isLoading()) {
        <ion-row
          [class.feedback-margin]="
            step.feedback && platform.is('ios') === false
          "
          [class.feedback-self-check]="isSelfCheckFeedback()"
        >
          <ion-col class="question-container" size="12">
            <lib-question-control
              [questionData]="step"
              [formControl]="_questionFormCtrl"
            />
          </ion-col>
          @if (!step.feedback) {
            <ion-col class="ion-margin-top">
              <lib-clue
                [sessionId]="stepSupplierService.getSessionId()"
                [hints]="step.question.hints"
              />
            </ion-col>
          }
        </ion-row>
        @if (!step.feedback) {
          <lib-footer
            [step]="step"
            [disablePrevButton]="isLoading()"
            [disableNextButton]="isLoading() || _questionFormCtrl.invalid"
            (prev)="onPrevClicked()"
            (next)="onNextClicked($event)"
          />
        } @else {
          <lib-feedback
            [class.md]="platform.is('ios') === false"
            [step]="step"
            [feedback]="step.feedback"
            (onNextQuestion)="onNextFeedbackClick($event)"
            [disabled]="isLoading()"
          />
        }
        <lyceo-support-mailto-alfred
          [questionAmount]="step.totalQuestions"
          [questionPosition]="step.position"
        />
      } @else {
        <ion-skeleton-text [animated]="true" />
        <ion-skeleton-text [animated]="true" />
        <ion-skeleton-text [animated]="true" />
      }
    </ion-col>
  </ion-row>
} @else {
  <ion-skeleton-text [animated]="true" />
  <ion-skeleton-text [animated]="true" />
  <ion-skeleton-text [animated]="true" />
}
